import React, { useEffect, useRef, useState } from "react";

const LocationPicker = ({ onLocationSelect, initialPosition }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerInstance = useRef(null);
  const [initialized, setInitialized] = useState(false);
  
  useEffect(() => {
    // Check if Google Maps is loaded
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API not loaded");
      return;
    }

    // Initialize map only once
    if (!initialized) {
      const initialCenter = initialPosition || { lat: 25.2048, lng: 55.2708 };
      
      mapInstance.current = new window.google.maps.Map(mapRef.current, {
        center: initialCenter,
        zoom: 12,
      });

      // Add click listener ONCE
      mapInstance.current.addListener("click", (e) => {
        handleLocation(e.latLng.lat(), e.latLng.lng());
      });

      setInitialized(true);
      
      // If initial position is provided, set the marker
      if (initialPosition) {
        // Use a small delay to ensure map is ready
        setTimeout(() => {
          handleLocation(initialPosition.lat, initialPosition.lng);
        }, 500);
      }
    }
  }, [initialized]);

  // Update marker when initialPosition changes (but map is already initialized)
  useEffect(() => {
    if (initialized && initialPosition && mapInstance.current) {
      handleLocation(initialPosition.lat, initialPosition.lng);
    }
  }, [initialPosition, initialized]);

  const handleLocation = (lat, lng) => {
    if (!mapInstance.current) return;

    // Remove old marker
    if (markerInstance.current) markerInstance.current.setMap(null);

    // Add new marker
    markerInstance.current = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapInstance.current,
    });

    // Move map center
    mapInstance.current.setCenter({ lat, lng });

    // Reverse geocode
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const comps = results[0].address_components;
        let city = "";
        let state = "";
        let country = "";

        comps.forEach((c) => {
          if (c.types.includes("locality")) city = c.long_name;
          if (c.types.includes("administrative_area_level_1"))
            state = c.long_name;
          if (c.types.includes("country")) country = c.long_name;
        });

        // Call the callback with the location data
        if (onLocationSelect) {
          onLocationSelect({
            lat,
            lng,
            address: results[0].formatted_address,
            city,
            state,
            country,
          });
        }
      }
    });
  };


  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div 
        ref={mapRef} 
        style={{ width: "100%", height: "400px", border: "1px solid #ddd", borderRadius: "4px" }} 
      />
    </div>
  );
};

export default LocationPicker;